import { render, staticRenderFns } from "./ProjectIntegrationSystemBadge.vue?vue&type=template&id=35803852"
import script from "./ProjectIntegrationSystemBadge.vue?vue&type=script&lang=js"
export * from "./ProjectIntegrationSystemBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports